import PricingComponent from './PricingComponent';

type TaxType = {
  type: string;
};

type TaxPortion = {
  name: string;
  taxType: TaxType;
  rate: number;
  centAmount: number;
  taxCountry: string;
  key: string;
};

class PricingData {
  taxes: TaxPortion[];

  components: PricingComponent[];

  constructor() {
    this.taxes = [];
    this.components = [];
  }
}

export default PricingData;
